var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height: ${_vm.height};`)},[_c('div',{class:[{'float-right': !_vm.noRight}]},[_c('v-pagination',{staticClass:"mt-2 theme--light",attrs:{"length":_vm.pageCount,"total-visible":_vm.totalVisible},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }